import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';
import { ApiExporterRef } from './api/ApiDefExporterApi';
import { ApiDefExporterClient } from './api/ApiDefExporterClient';

export const apiExporterPlugin = createPlugin({
  id: 'api-exporter',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: ApiExporterRef,
      deps: { discoveryApi: discoveryApiRef, identityApi: identityApiRef },
      factory: ({ discoveryApi, identityApi }) =>
        new ApiDefExporterClient({ discoveryApi, identityApi }),
    }),
  ],
});

export const ApiExporterPage = apiExporterPlugin.provide(
  createRoutableExtension({
    name: 'ApiExporterPage',
    component: () => import('./components/MainComponent').then(m => m.MainPage),
    mountPoint: rootRouteRef,
  }),
);
